import dayjs from 'dayjs';
import { CalendarEntry } from './calendar-entry.js';
import { Duration } from 'dayjs/plugin/duration.js';
import { CalendarOrderItem } from './serializable/calendar-order-item.js';
import { LegacyCustomerOrderBase } from '../contracts/customer-order.js';
import { OnlinePaymentDetails } from './serializable/online-payment-details.js';
import { PaymentType } from './serializable/payment-type.js';
import { PaymentStatus } from './serializable/payment-status.js';
import { Language } from './serializable/language.js';
import { PaymentMethod } from './serializable/payment-method.js';
import { CustomerAccountBase } from './serializable/customer-account-base.js';
import { CustomerProfile } from './serializable/customer-profile.js';
import { Country } from './serializable/country.js';
import { OrderDomain } from './serializable/order-domain.js';
import { OrderSource } from './serializable/order-source.js';
import { DataModel } from './dto/dto.js';

export abstract class CalendarOrderBase extends CalendarEntry implements LegacyCustomerOrderBase {
  get isGuestOrder(): boolean {
    return false;
  }

  get isLegacyOrder(): true {
    return true;
  }

  abstract get services(): CalendarOrderItem[];
  abstract get customerId(): string | null;
  abstract get userId(): string | null;
  abstract get country(): Country;
  abstract get language(): Language | null;
  abstract get source(): OrderSource;
  abstract get domain(): OrderDomain;
  abstract get paymentType(): PaymentType;
  abstract get paymentMethod(): PaymentMethod;
  abstract get onlinePaymentDetails(): OnlinePaymentDetails | null;

  abstract copyWithPaymentDetails(paymentDetails: OnlinePaymentDetails): this;
  abstract copyWithPaymentStatus(status: PaymentStatus): this;
  abstract copyWithPaymentMethod(paymentMethod: PaymentMethod): this;
  abstract assignToCustomerAccount(account: CustomerAccountBase): this;
  abstract tryGetCustomer(): CustomerProfile | null;

  static calculateTotalDuration(services: CalendarOrderItem[]): Duration {
    let duration = 0;
    for(const service of services) {
      duration += service.duration.asMilliseconds();
    }

    return dayjs.duration(duration, 'milliseconds');
  }
  
  static verifyType(order: DataModel): boolean {
    return order instanceof CalendarOrderBase;
  }

  static assertType(order: DataModel): order is CalendarOrderBase {
    return order instanceof CalendarOrderBase;
  }
}
